import { ProviderGroup, ProviderGroupItemSummary } from '../../../../lib/helpers/SmartSendBulkActionApplier';

export function GroupHasVat(group: ProviderGroup) {
  return group.TotalVat > 0;
}
export function GroupHasDuties(group: ProviderGroup) {
  return group.Duties > 0;
}
export function ItemHasVat(group: ProviderGroupItemSummary) {
  return group.TotalPrice !== group.TotalPriceExVat || group.TotalVat > 0;
}
